import { render, staticRenderFns } from "./PersonalBasicSalaryManagement.vue?vue&type=template&id=4c7f8ace"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports